import type { VulcanApplication } from '@repo/vulcan-tools'
import configuredApps from './vulcan.config.json'

export interface VulcanAppDefinition extends VulcanApplication {
  id: 'cloud-agent-manager' | 'workspaces-console'
  description: string
  icon: 'cloud' | 'workspaces'
}

export const VULCAN_APP_CONFIG = configuredApps as readonly VulcanAppDefinition[]

export function appForPath(pathname: string, apps: readonly VulcanAppDefinition[] = VULCAN_APP_CONFIG) {
  return (
    apps.find((app) => pathname === app.path || pathname.startsWith(`${app.path}/`)) ??
    apps.find((app) => app.path === '/') ??
    apps[0]
  )
}
